import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../../../context/LanguageContext';
import { ROUTES } from '../../../routes/Paths';
import { trackPhoneClick } from '../../email/utils/trackingUtils';
import '../style/help-card.css';

interface HelpCardProps {
    className?: string;
}

const HelpCard: React.FC<HelpCardProps> = ({ className = '' }) => {
    const { language } = useLanguage();

    return (
        <div className={`help-card-wrapper ${className}`}>
            <div className="help-card">
                <div className="help-card__icon">
                    <i className="fas fa-question-circle"></i>
                </div>
                <div className="help-card__content">
                    <h3 className="help-card__title">
                        {language === 'pt' ? 'Precisa de Mais Ajuda?' : 'Need More Help?'}
                    </h3>
                    <p className="help-card__text">
                        {language === 'pt' 
                            ? 'Se pretende um orçamento detalhado ou tem dúvidas sobre os nossos serviços, não hesite em pedir um orçamento personalizado. A nossa equipa está pronta para ajudá-lo a encontrar a melhor solução para o seu veículo.'
                            : 'If you need a detailed quote or have questions about our services, don\'t hesitate to request a personalized quote. Our team is ready to help you find the best solution for your vehicle.'}
                    </p>
                    <div className="help-card__buttons">
                        <Link to={ROUTES.BUDGET} className="thm-btn help-card__btn help-card__btn--primary">
                            {language === 'pt' ? 'Peça orçamento' : 'Request Quote'}
                            <span><i className="icon-next"></i></span>
                        </Link>
                        <a
                            href="tel:+351255866191"
                            className="thm-btn help-card__btn help-card__btn--secondary"
                            onClick={() => trackPhoneClick('help_card')}
                        >
                            {language === 'pt' ? 'Fale connosco' : 'Call us'}
                            <span><i className="icon-phone-call"></i></span>
                        </a>
                        {/* "Nós Ligamos" button hidden at the customer's request (2026-10-06) — restore by uncommenting
                        <Link to={ROUTES.WE_CALL} className="thm-btn help-card__btn help-card__btn--secondary">
                            {language === 'pt' ? 'Nós Ligamos' : 'We\'ll Call You'}
                            <span><i className="icon-phone-call"></i></span>
                        </Link>
                        */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HelpCard;

